import { restApi } from '@icp/settings';

// 以前 favoriteView 是存到 localstorage 的，现在改为存到远程数据库了，需要做 migrate
export function migrateLocalToRemote(key, url) {
  if (!key || !url) {
    return;
  }

  const localSettings = loadSetting(key);
  if (!Object.keys(localSettings).length || !localSettings.favoriteView) {
    return;
  }

  const { favoriteView, ...other } = localSettings;

  // favoriteView 存储到远程服务器，其余状态保留到浏览器
  restApi
    .post(`${url}/create-or-update`, {
      key,
      value: JSON.stringify({ favoriteView }),
      scope: 'user',
    })
    .then(() => {
      localStorage.setItem(key, JSON.stringify(other));
    });
}

export function saveSetting(key, obj) {
  if (!key) return;
  const settings = loadSetting(key);
  const newSettings = { ...settings, ...obj };
  if (settings.favoriteView) {
    newSettings.favoriteView = settings.favoriteView;
  }
  localStorage.setItem(key, JSON.stringify(newSettings));
}

export function loadSetting(key) {
  if (!key) return {};
  return JSON.parse(localStorage.getItem(key)) || {};
}

export function clearSetting(key) {
  if (!key) return;
  const { favoriteView } = loadSetting(key);
  if (favoriteView) {
    localStorage.setItem(key, JSON.stringify({ favoriteView }));
  } else {
    localStorage.removeItem(key);
  }
}

export function loadFavoriteView(key, globalKey, url) {
  if (url) {
    return Promise.all([restApi.get(`${url}/key/${key}`), restApi.get(`${url}/key/${globalKey}`)])
      .then((res) => {
        return [
          res[0] ? JSON.parse(res[0].value) : null,
          res[1] ? JSON.parse(res[1].value) : null,
          //
        ];
      })
      .then((res) => {
        return [res[0]?.favoriteView || {}, res[1]?.favoriteView || {}];
      })
      .then(([userRes, globalRes]) => {
        return {
          ...userRes,
          viewList: [...(globalRes.viewList || []), ...(userRes.viewList || [])],
        };
      });
  }

  return Promise.resolve(loadSetting(key).favoriteView);
}

export function saveFavoriteView(key, globalKey, url, favoriteView, oldFavoriteView) {
  if (url) {
    const userViewList = favoriteView.viewList.filter((item) => !item.isGlobal);
    const oldUserViewList = oldFavoriteView.viewList.filter((item) => !item.isGlobal);
    const globalViewList = favoriteView.viewList.filter((item) => item.isGlobal);
    const oldGlobalViewList = oldFavoriteView.viewList.filter((item) => item.isGlobal);
    if (oldUserViewList.length && !userViewList.length) {
      restApi.delete(`${url}/key/${key}`);
    } else if (userViewList.length) {
      restApi.post(`${url}/create-or-update`, {
        key,
        value: JSON.stringify({
          favoriteView: { current: favoriteView.current, viewList: userViewList },
        }),
        scope: 'user',
      });
    }
    if (oldGlobalViewList.length && !globalViewList.length) {
      restApi.delete(`${url}/key/${globalKey}`);
    } else if (globalViewList.length) {
      restApi.post(`${url}/create-or-update`, {
        key: globalKey,
        value: JSON.stringify({ favoriteView: { viewList: globalViewList } }),
        scope: 'global',
      });
    }
  } else {
    const settings = loadSetting(key);
    const newSettings = { ...settings, favoriteView };
    localStorage.setItem(key, JSON.stringify(newSettings));
  }
}
